/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
import * as React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MailIcon from '@mui/icons-material/Mail';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { Redirect, Route, Switch } from "react-router";
import UpcomingDrops from "pages/Main/UpcomingDrops";
import Home from "pages/Main/Home";
import Services from "pages/Main/Services";
import { Link, useLocation } from 'react-router-dom';
import Header from 'components/Header';
import { discordLogoBtn, logo } from 'assets/images/image'
import P from 'components/Font/P';
import DiscordLogoIcon from 'components/Svg/DiscordLogoIcon';

const drawerWidth = 240;

function ResponsiveDrawer(props) {
  const location = useLocation();
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  React.useEffect(() => {
    console.log(location)
  }, [])


  const drawer = (
    <Box>
      <Box sx={{ py: 4, textAlign: 'center' }}>
        <img src={logo} alt="logo" />
      </Box>
      <Box component={Link} to="/home" className='nav-item-con' sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer', py: 2 }}>
        <Box className={location.pathname == "/home" ? "menu-select-bar selected" : "menu-select-bar"}></Box>
        <Box sx={{}}>
          <P uppercase color={location.pathname == "/home" ? '#d77e7e' : 'unset'}>Home</P>
        </Box>
      </Box>
      <Box component={Link} to="/upcoming-drops" className='nav-item-con' sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer', py: 2 }}>
        <Box className={location.pathname == "/upcoming-drops" ? "menu-select-bar selected" : "menu-select-bar"}></Box>
        <Box sx={{}}>
          <P uppercase color={location.pathname == "/upcoming-drops" ? '#d77e7e' : 'unset'}>Upcoming Drops</P>
        </Box>
      </Box>
      <Box component={Link} to="/services" className='nav-item-con' sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer', py: 2 }}>
        <Box className={location.pathname == "/services" ? "menu-select-bar selected" : "menu-select-bar"}></Box>
        <Box sx={{}}>
          <P uppercase color={location.pathname == "/services" ? '#d77e7e' : 'unset'}>Services &amp; Ads</P>
        </Box>
      </Box>
      <Box sx={{ px: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', py: 2 }}>
          <Box className='btn btn-pink-gradient' sx={{ px: 2, py: 1, width: '100%', }}>
            <P textAlign="center" color={"#323232"}>Submit Collection</P>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', py: 2 }}>
          <Box className='btn btn-purple-gradient' sx={{ px: 2, py: 1.2, width: '100%', display: 'flex', justifyContent: 'center' }}>
            <img src={discordLogoBtn} alt="discord-logo-btn" className='discord-logo-btn' />
          </Box>
        </Box>
      </Box>
    </Box>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: 'flex', height: '100%' }}>
      <CssBaseline />
      <Header drawerWidth={drawerWidth} handleDrawerToggle={() => { handleDrawerToggle() }} />
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, border: 'none' },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          style={{ background: 'third.main' }}
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, border: 'none' },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        className='main-container'
        sx={{ flexGrow: 1, p: 3, width: { sm: `calc(100% - ${drawerWidth}px)` } }}
      >
        <Switch>
          <Route
            path="/home"
            component={(props) => <Home {...props} />}
          ></Route>
          <Route
            path="/upcoming-drops"
            component={(props) => <UpcomingDrops {...props} />}
          ></Route>
          <Route
            path="/services"
            component={(props) => <Services {...props} />}
          ></Route>
          <Redirect to="/home" />
        </Switch>
      </Box>
    </Box>
  );
}

ResponsiveDrawer.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default ResponsiveDrawer;